import { z } from 'zod';

import { CandidateSchema } from './candidate';
import { BarredLocationSchema } from './barred-locations';
import { ExperienceSchema } from './experience';

export const CandidateProfileHighlightsSchema = CandidateSchema.pick({
  addressCountry: true,
  addressState: true,
  industries: true,
  lawFirms: true,
  primaryFocusArea: true,
  primaryPracticeArea: true,
  yearsOfExperience: true,
}).extend({
  barredLocations: z.array(
    BarredLocationSchema.pick({
      name: true,
      addressState: true,
      addressCountry: true,
    })
  ),
  topFocusAreas: z.array(
    z.object({
      focusArea: z.string(),
      yearsOfExperience: z.number(),
      experiences: z.array(
        ExperienceSchema.pick({
          client: true,
          startDate: true,
          endDate: true,
          isAxiom: true,
        })
      ),
    })
  ),
});

export type CandidateProfileHighlights = z.infer<
  typeof CandidateProfileHighlightsSchema
>;
